import { fetchWrapper } from '@/_helpers';
const BASE_ROUTE = 'email-drafts';

const getChatroomEmailDrafts = ({ chatroomId, status = 'draft' } = {}) => {
    const query = new URLSearchParams();
    if (chatroomId) query.set('chatroom', chatroomId);
    if (status) query.set('status', status);
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return fetchWrapper.get(`${BASE_ROUTE}${suffix}`);
};

const getChatroomEmailDraftById = ({ chatroomId, emaildraftId } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.get(`${BASE_ROUTE}/${emaildraftId}${query}`);
};

const generateChatroomEmailDraft = ({ chatroomId, payload } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.post(`${BASE_ROUTE}/generate${query}`, payload || {});
};

const createChatroomEmailDraft = ({ chatroomId, payload } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.post(`${BASE_ROUTE}${query}`, payload || {});
};

const updateChatroomEmailDraftById = (emaildraftId, { chatroomId, payload } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.put(`${BASE_ROUTE}/${emaildraftId}${query}`, payload || {});
};

const sendChatroomEmailDraft = (emaildraftId, { chatroomId } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.post(`${BASE_ROUTE}/${emaildraftId}/send${query}`);
};

const deleteChatroomEmailDraft = (emaildraftId, { chatroomId } = {}) => {
    const query = chatroomId ? `?chatroom=${encodeURIComponent(chatroomId)}` : '';
    return fetchWrapper.delete(`${BASE_ROUTE}/${emaildraftId}${query}`);
};

export const emailDraftService = {
    getChatroomEmailDrafts,
    getChatroomEmailDraftById,
    generateChatroomEmailDraft,
    createChatroomEmailDraft,
    updateChatroomEmailDraftById,
    saveChatroomEmailDraft: createChatroomEmailDraft,
    saveChatroomEmailDraftById: updateChatroomEmailDraftById,
    sendChatroomEmailDraft,
    deleteChatroomEmailDraft,
};
